export const PLANNING_LOOKUP_LINK = 'https://fastvalue.vn/xem-quy-hoach';
export const PLANNING_LOOKUP_CONFIRM = 'Ứng dụng Tra cứu Quy hoạch được cung cấp miễn phí cho Cộng Đồng Thẩm Định Giá tại trang chủ Fastvalue.vn - Chúng tôi sẽ chuyển bạn đến trang này. Bạn có muốn tiếp tục ?';
